import { OfferType } from '@occc-app/offerValidationService/types';
import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { ZodValidationError } from '@occc/ui-forms';

import { ProductChallengeFormSchema, VisitChallengeFormSchema } from './schemas';
import { ChallengeConfigureFormValues } from './types';
import { ChallengeType } from './constants';

import { createRouteCreator } from '../CampaignComponents/utils';

export const routeCreator = createRouteCreator(OfferType.Challenge);

const validatorByChallengeType: Record<
  ChallengeType,
  (value: unknown) => Promise<ZodValidationError>
> = {
  [ChallengeType.ProductChallenge]: makeValidate(ProductChallengeFormSchema),
  [ChallengeType.VisitChallenge]: makeValidate(VisitChallengeFormSchema),
};

export const validateConfiguration = async (values: ChallengeConfigureFormValues) => {
  if (values.challengeType == null) {
    return;
  }

  return validatorByChallengeType[values.challengeType](values);
};
